
import { useDroppable } from '@dnd-kit/core'
import { Box } from '@chakra-ui/react'

interface CanvasDropZoneProps {
  children: React.ReactNode
}

export function CanvasDropZone({ children }: CanvasDropZoneProps) {
  const { setNodeRef, isOver } = useDroppable({
    id: 'canvas-drop-zone',
  })

  return (
    <Box
      ref={setNodeRef}
      minH="200px"
      p={4}
      border={isOver ? '2px dashed' : 'none'}
      borderColor={isOver ? 'blue.500' : 'transparent'}
      borderRadius="md"
      bg={isOver ? 'blue.50' : 'transparent'}
      transition="all 0.2s"
      onClick={(e) => e.stopPropagation()}
    >
      {children}
    </Box>
  )
}

